module.exports = __webpack_public_path__ + "img/Lisa-HERO.3b801ce5.jpg";